import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { FeldQuerySorterConfig } from 'fa-kt.types';
import { FeldService } from '../service';

@Component({
  selector: 'fa-kt-feld-sorter',
  templateUrl: './feld-sorter.component.html',
  styleUrls: ['./feld-sorter.component.css'],
})
export class FeldSorterComponent {
  public FeldSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public feld: FeldService,
  ) {
    this.FeldSorterConfig = FeldQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
